import { SELLER_REPORT_REVISION, validateSellerReport, translationTexts, validateTranslations } from './schema';
import { renderSellerReport } from './render';
export const conf = {
  id: 'seller-company', name: 'Seller company intelligence',
  description: 'Company overview, full opportunities and evidence, business intelligence, priorities, brand and contact channels.',
  revision: SELLER_REPORT_REVISION, sourceKinds: ['seller'] as const, pdfBucket: 'campaign-report-exports' as const,
  sectionConfig: false, i18n: 'ai' as const,
};
export const reportTemplate = { conf, validate: validateSellerReport, translationTexts, validateTranslations, render: renderSellerReport };
